import {Type} from "class-transformer";
import {DocFile, serializeType, SolutionManager, Transaction} from "@app/shared";

export enum ImportTemplateType {
  Onboard = "ONBOARD",
  Transaction = "TRANSACTION"
}

export enum ImportTemplateSubtype {
  JournalEntryAcc = "JOURNAL_ENTRY_ACC",
  InvoiceTemplate = "INVOICE_TEMPLATE",
  TimesheetImport = "TIMESHEET_IMPORT",
  VendorInvoiceImport = "VENDOR_INVOICE_IMPORT"
}

export class ImportTemplate extends SolutionManager {
  validated: string;
  transaction: Transaction;
  @Type(serializeType(DocFile)) docFile?: DocFile;
  enabled: boolean;
  type: ImportTemplateType;
  subtype?: ImportTemplateSubtype;
  description: string;
  loadOrder: number;
  dependencies: string;
  @Type(serializeType(Date)) uploadedOn?: Date;
  lastUploadedBy: string;

  constructor(managingOrgId?: number) {
    super(managingOrgId);
    this.enabled = true;
  }
}

export class ImportError {
  id?: number;
  version?: number;

  rowNumber: number;
  excelError: string;
  evidence: string;
}

export class ImportFile extends SolutionManager {
  status: string;
  transaction: Transaction;
  @Type(serializeType(ImportTemplate)) importTemplate?: ImportTemplate;
  @Type(serializeType(DocFile)) docFile?: DocFile;
  enabled: boolean;
  description: string;
  dependencies: string[];
  @Type(serializeType(ImportError)) importErrors?: ImportError[];
  @Type(serializeType(Date)) uploadedOn?: Date;
  lastUploadedBy: string;
  @Type(serializeType(Date)) importedOn?: Date;
  lastImportedBy: string;


  constructor (managingOrgId?: number) {
    super(managingOrgId);
  }
}

export enum ImportType {
  Template = "TEMPLATE",
  ProcessedTemplate = "PROCESSED_TEMPLATE",
  Import = "IMPORT"
}
